import React from 'react'
import './footer.css'
import {FaFacebookF} from 'react-icons/fa'
import {BsInstagram} from 'react-icons/bs'
import {BsTwitter} from 'react-icons/bs'


const footer = () => {
  return (
   <footer>
    <a href="#" className='footer__logo'>SEWWANDI</a>
    <ul className='permalinks'>
      <li><a href="#">Home</a></li>
      <li><a href="#about">Home</a></li>
      <li><a href="#experience">Experience</a></li>
      <li><a href="#service">Services</a></li>
      <li><a href="#portfolio">Portfolio</a></li>
      <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://facebook.com"><FaFacebookF/></a>
        <a href="https://instargram.com"><BsInstagram/></a>
        <a href="https://twitter.com"><BsTwitter/></a>

      </div>

      <div className="footer__copyright">
        <small>&copy; Design By Sewwandi maheshika.</small>

      </div>
     

   </footer>
  )
}

export default footer